<textarea #field
          class="form-control"
          [ngModel]="innerValue"
          (ngModelChange)="writeValue($event)"
          (blur)="onTouched()">
</textarea>
